import { render } from "./newMtzlsAgreement.vue?vue&type=template&id=6497ad31"
import script from "./newMtzlsAgreement.vue?vue&type=script&lang=js"
export * from "./newMtzlsAgreement.vue?vue&type=script&lang=js"

import "./newMtzlsAgreement.vue?vue&type=style&index=0&id=6497ad31&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__